// extracted by mini-css-extract-plugin
export default {"price-setup-list__container":"SeasonList_price-setup-list__container__2S+aF"};